<template>
  <div
    v-if="isSyteEnabled && variantIds.length"
    id="syte-fbt-container"
    class="col-span-full"
    :data-skus="placement === 'PDP' ? variantIds[0] : variantIds"
    :data-placement="placement"
  ></div>
</template>

<script setup lang="ts">
// https://aboutyou.atlassian.net/browse/SCFIM-2181
// col-span-full required for desktop (doesnt affect mobile)
defineProps({
  variantIds: {
    type: Array as PropType<number[]>,
    required: true,
  },
  placement: {
    type: String as PropType<'PDP' | 'Cart'>,
    required: true,
  },
})

const { isSyteEnabled } = useFeatureToggles()
</script>
